import styles from './RichListItemContent.module.scss';

import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function RichListItemContent(props: Props) {
  const className = clsx(styles['root']);

  return <div className={className}>{props.children}</div>;
}
